// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"369":"1ecdb9f7","2589":"a26414d0","2611":"1ecdb9f7","3895":"a26414d0","4544":"1ecdb9f7","5943":"a26414d0","8987":"933f3c16"}[chunkId] + ".chunk.css";
};